import React from "react";

function Home() {
    return <span></span>;
}

export default Home;
